import { useNavigate } from "react-router-dom";
import classes from "./ProductCard.module.css";
import { PLACEHOLDER_IMAGE } from "../../utils/image";

export default function ProductCard({ product }) {
  const navigate = useNavigate();

  const handleViewProduct = () => {
    const slug = product.product_slug || product.sku;
    navigate(`/product/${slug}`);
  };

  const displayName =
    product.productName.length > 40
      ? product.productName.slice(0, 40) + "..."
      : product.productName;

  const showPrice = parseFloat(product.regularPrice) > 0;

  const handleImgError = (e) => {
    if (e?.target && e.target.src !== PLACEHOLDER_IMAGE) {
      e.target.src = PLACEHOLDER_IMAGE;
    }
  };

  return (
    <div
      className={classes.productCard}
      onClick={handleViewProduct}
      role="button"
    >
      <div className={classes.productCardInnerWrapper}>
        <div className={classes.productImage}>
          {product.categoryName && (
            <span className={classes.badge}>{product.categoryName}</span>
          )}
          <img
            src={product.productImage}
            alt={product.productName}
            onError={handleImgError}
          />
        </div>

        <div className={classes.productContent}>
          <h3 title={product.productName}>{displayName}</h3>

          <div className={classes.priceWrap}>
            <p className={classes.productSku}>SKU: {product.sku}</p>
            {/* {showPrice && (
              <p className={classes.productPrice}>
                {product.salePrice && parseFloat(product.salePrice) > 0 ? (
                  <>
                    <span
                      style={{
                        textDecoration: "line-through",
                        color: "#999",
                        marginRight: "0.5rem",
                      }}
                    >
                      £
                      {Number(product.regularPrice).toLocaleString("en-UK", {
                        minimumFractionDigits: 2,
                      })}
                    </span>
                    £
                    {Number(product.salePrice).toLocaleString("en-UK", {
                      minimumFractionDigits: 2,
                    })}
                  </>
                ) : (
                  `£${Number(product.regularPrice).toLocaleString("en-UK", {
                    minimumFractionDigits: 2,
                  })}`
                )}
              </p>
            )} */}
          </div>
        </div>
      </div>
    </div>
  );
}
